import React, { useEffect, useState } from "react"
import {
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  Table,
} from "reactstrap"
import plusIcon from "../../../assets/icons/plusIcon.svg"
import minusIcon from "../../../assets/icons/minusIcon.svg"
import NumberFormat from "../../../utils/numberFormat"
import arrow from "../../../assets/icons/arrow.svg"
import { useNavigate } from "react-router-dom"
import UpdateTable from "../../../components/Common/UpdatedTable"
import { useDispatch } from "react-redux"
import { setFilter } from "../../../store/actions"

const BalanceSheetAccordion = ({
  data = [],
  parentKey = "root",
  startDate,
  endDate,
  menuLabell,
  onOpenChange,
  forceOpenAll = false,
}) => {
  const [open, setOpen] = useState("")
  const dispatch = useDispatch()
  // const toggle = id => {
  //   setOpen(open === id ? "" : id)
  // }

  const navigate = useNavigate()

  const desimalrange = localStorage.getItem("desimalrange")

  const notifyParent = openArray => {
    if (typeof onOpenChange !== "function") return
    try {
      if (onOpenChange.length >= 2) {
        onOpenChange(parentKey, openArray)
      } else {
        onOpenChange(openArray)
      }
    } catch (err) {
      try {
        onOpenChange(openArray)
      } catch (e) {
        /* noop */
      }
    }
  }

  // collect all ids in this subtree (recursive)
  const collectAllIds = arr => {
    const ids = []
    const walk = items => {
      items?.forEach(it => {
        if (it?.id != null) ids.push(String(it.id))
        if (it?.sub_groups?.length) walk(it.sub_groups)
      })
    }
    walk(arr)
    return ids
  }

  // when forceOpenAll toggles, set open to all ids (or collapse)
  useEffect(() => {
    if (forceOpenAll) {
      const ids = collectAllIds(data)
      setOpen(ids)
      notifyParent(ids)
    } else {
      // Collapse when leaving force-open mode. If you prefer to keep user's open state,
      // remove the two lines below.
      setOpen([])
      notifyParent([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forceOpenAll, data])

  // toggle by data id - disabled when forceOpenAll is true
  const toggle = id => {
    if (forceOpenAll) return
    const idStr = String(id)
    const exists = open.includes(idStr)
    const newOpen = exists ? open.filter(x => x !== idStr) : [...open, idStr]
    setOpen(newOpen)
    notifyParent(newOpen)
  }

  // notify parent whenever open changes
  useEffect(() => {
    notifyParent(open)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  const assetColumns = [
    {
      label: "Group Name",
      renderCell: item => (
        <div
          onClick={() => {
            navigate(`/finance-ledger-acc`, {
              state: { item, startDate, endDate, menuLabell },
            })
          dispatch(setFilter({dateFrom: startDate, dateTo: endDate}))
          }
          }
          className="pointer fw-bold ps-3"
        >
          {item?.ledger_name}
          <span className="ps-1">
            <img src={arrow} alt="" width="7" />
          </span>
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Credit</div>,
      renderCell: item => (
        <div
          className={`${
            item?.balance_type == "credit" ? "" : ""
          } text-end pe-5`}
        >
          {NumberFormat(
            Math.abs(
              Number(item?.credit) > Number(item?.debit)
                ? Number(item?.credit) - Number(item?.debit)
                : Number(item?.debit) - Number(item?.credit)
            ),
            desimalrange,
            desimalrange
          )}{" "}
          {/* {Number(item?.credit) != 0 ? "Cr" : "Dr"} */}
          {/* {NumberFormat(
              Math.abs(Number(item?.balance ? item?.balance : 0)),
              3,
              3
            )}{" "}
            {Number(item?.balance) > 0 ? "Cr" : "Dr"} */}
        </div>
      ),
    },
  ]

  return (
    <Accordion open={open} toggle={toggle}>
      {data?.map((item, index) => {
        // const currentKey = `${parentKey}-${index}`
        // const isOpen = open === currentKey

        const currentKey =
          item?.id != null ? String(item.id) : `${parentKey}-${index}`
        const isOpen = open.includes(currentKey)
        // const showExpander = item?.ledgers?.length > 0 || item?.sub_groups?.length > 0

        return (
          <AccordionItem key={item.id || currentKey}>
            <AccordionHeader
              targetId={currentKey}
              className="d-flex align-items-center w-100 pointer custom-header-accordion py-0"
            >
              {/* Column 1: Icon + Group Name */}
              <div className="w-50 d-flex align-items-center">
                {/* <img
                  src={isOpen ? minusIcon : plusIcon}
                  alt={isOpen ? "Collapse" : "Expand"}
                  style={{ width: "8px", height: "8px", marginRight: "4px" }}
                /> */}
                {(item?.ledgers?.length > 0 ||
                  item?.sub_groups?.length > 0) && (
                  <img
                    src={isOpen ? minusIcon : plusIcon}
                    alt={isOpen ? "Collapse" : "Expand"}
                    style={{ width: "8px", height: "8px", marginRight: "4px" }}
                  />
                )}
                {item.group_name}
              </div>

              {/* Column 2: Debit */}
              <div className="w-50 pe-5 text-end">
                {NumberFormat(
                  Math.abs(
                    Number(item?.credit) > Number(item?.debit)
                      ? Number(item?.credit) - Number(item?.debit)
                      : Number(item?.debit) - Number(item?.credit)
                  ),
                  desimalrange,
                  desimalrange
                )}
              </div>

              {/* Column 3: Credit */}
              {/* <div className="w-25 pe-5 text-end">
                {item?.credit
                  ? `${NumberFormat(
                      Math.abs(
                        Number(item?.credit) > Number(item?.debit)
                          ? Number(item?.credit) - Number(item?.debit)
                          : 0
                      ),
                      desimalrange,
                      desimalrange
                    )}`
                  : "-"}
              </div> */}
            </AccordionHeader>

            <AccordionBody accordionId={currentKey} className="py-0">
              {/* Ledgers Table */}
              {item.ledgers?.length > 0 && (
                // <Table bordered size="sm">
                //   <tbody>
                //     {item.ledgers.map((ledger) => (
                //       <tr key={ledger.id}>
                //         <td style={{ width: "50%" }}>{ledger.ledger_name}</td>
                //         <td style={{ width: "25%", textAlign: "right" }}>
                //           {ledger.debit.toLocaleString()}
                //         </td>
                //         <td style={{ width: "25%", textAlign: "right" }}>
                //           {ledger.credit.toLocaleString()}
                //         </td>
                //       </tr>
                //     ))}
                //   </tbody>
                // </Table>
                <UpdateTable
                  //   className="mt-2"
                  nodes={item.ledgers}
                  columns={assetColumns}
                  handilpagedrop={false}
                  tableWidth="50% 50%"
                  mobileWidth="50% 50%"
                  headerHide={true}
                />
              )}

              {/* Recursive sub-groups */}
              {item.sub_groups?.length > 0 && (
                <BalanceSheetAccordion
                  data={item?.sub_groups}
                  parentKey={currentKey}
                  onOpenChange={onOpenChange}
                  forceOpenAll={forceOpenAll}
                />
              )}
            </AccordionBody>
          </AccordionItem>
        )
      })}
    </Accordion>
  )
}

export default BalanceSheetAccordion
